import { render } from "./FuturePaymentsForm.vue?vue&type=template&id=5d2c3245"
import script from "./FuturePaymentsForm.vue?vue&type=script&lang=js"
export * from "./FuturePaymentsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__